const NewsTypes = {
  FETCH_NEWS_START: 'FETCH_NEWS_START',
  FETCH_NEWS_SUCCESS: 'FETCH_NEWS_SUCCESS',
  FETCH_NEWS_FAILED: 'FETCH_NEWS_FAILED',
};

export default NewsTypes;